import { Button } from 'antd';

import * as S from './styled';

type BillingServicesListEmptyProps = {
  onAdd: VoidFunction;
  canManageServices: boolean;
};

const BillingServicesListEmpty = ({
  onAdd,
  canManageServices,
}: BillingServicesListEmptyProps) => (
  <S.Container align="center" justify="center" vertical>
    <S.Title>There are no services yet</S.Title>

    <S.Description>
      Add services for this billing period to generate invoices and other
      payment documents
    </S.Description>

    {canManageServices && (
      <Button onClick={onAdd} size="large" ghost>
        Add service
      </Button>
    )}
  </S.Container>
);

export default BillingServicesListEmpty;
